import React, { useState, useRef } from 'react';
import { Button, Row, Col, Modal, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import BlockUi from 'react-block-ui';
import Toastr from '../utils/toastr';
import { useTranslation } from 'react-i18next';

function TwoFA(props) {
    const { t } = useTranslation();
    const [code, setCode] = useState("");
    const [emptyCode, setEmptyCode] = useState(false);
    const [loading, setLoading] = useState(false);
    const toastrRef = useRef();

    const sendCode = e => {
        if (code !== null && code.trim() !== "") {  
            props.toggleModal();
            setCode("");
            props.submit(code);
        } else {
            setEmptyCode(true);
          
        }
        

    }

    const resendCode = e => {
        setLoading(true);
        props.setToken(code);
        props.resend(() => {
            setLoading(false);
        });
    }

    return (<>
        <Modal show={props.show} onHide={props.toggleModal} size="lg">
            <BlockUi tag="div" blocking={loading} color="#009ef7" message={t("pleasewait")}>
                <Modal.Header closeButton>
                    <Modal.Title><FontAwesomeIcon icon={duotone("lock")} /> {t("codeequired")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <Form>
                                <Form.Group className="mb-4">
                                    <Form.Label>{t("code")}</Form.Label>
                                    <Form.Control type="text" value={code} onChange={e => { setCode(e.target.value); setEmptyCode(false); }} />
                                    {
                                        (emptyCode) &&
                                        <Form.Text id="passwordHelpBlock" className='text-danger'>
                                            {t("codecannotbenull")}
                                        </Form.Text>
                                    }
                                </Form.Group>
                            </Form>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={resendCode}>
                        {t("resend")}
                    </Button>
                    <Button variant="primary" onClick={sendCode}>
                        <FontAwesomeIcon icon={duotone("paper-plane-top")} />  {t("send")}
                    </Button>
                </Modal.Footer>
            </BlockUi>
        </Modal>
        <Toastr ref={toastrRef} />
    </>)
}


export default TwoFA;